
export const visible_sections = [
    "eligibility__visual_impairments",
    "eligibility__deafblindness",

    //    "certification__tvi",

    //    "certification__orientation___mobility"
];

export default {
    visible_sections
};